import { CsvSyncButton } from 'components/CsvButtons';
import { useTranslation } from 'react-i18next';

const data = [
  [
    'External Identifier',
    'Company Name',
    'Company Country',
    'Postal Code',
    'Company Address',
    'Company Description',
    'Commodities',
    'Employee Count',
    'Naics Codes',
  ],
  [
    'A24428161',
    'A. J. J. STORES SOCIEDAD ANONIMA.',
    'ES',
    '24750 LA BANEZA',
    'CALLE LA HEMINA B2',
    '',
    '',
    '',
    '',
  ],
  [
    'A25244849',
    'EUROFINS AGROAMBIENTAL, S.A.',
    'ES',
    '25222 SIDAMON',
    'PARTIDA SETSAMBS S/N',
    '',
    '',
    '',
    '',
  ],
  ['A25530163', 'GRINO ECOLOGIC SA', 'ES', '25007 LERIDA', 'PLAZA SANT JOAN 10', '', '', '', ''],
];

export default function SampleCsvLink() {
  const { t } = useTranslation('default');
  return <CsvSyncButton text={t('download-sample-csv')} data={data} />;
}
